export default __webpack_public_path__ + "static/media/EconomicsGoodsService_07.2cdb5fcb.png";